type IconExternalLinkProps = React.SVGProps<SVGSVGElement>;

const IconExternalLink = (props: IconExternalLinkProps) => {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M10.5 7.583v3.5a1.167 1.167 0 0 1-1.167 1.167H2.917A1.167 1.167 0 0 1 1.75 11.083V4.667a1.167 1.167 0 0 1 1.167-1.167h3.5M8.75 1.75h3.5v3.5M5.833 8.167l6.417-6.417"
        stroke="currentColor"
        strokeWidth={1.167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconExternalLink;

